// Components
import { Zoom } from "@mui/material";
// Hooks
import { useEffect, useState } from "react";
// Assets
import { ReactComponent as AnchorIcon } from "assets/icons/anchorButton.svg";
import imgCall from "../../../assets/icons/actionBtnCall.svg";
import whatsapp from "../../../assets/icons/whatsapp.svg";
// Styles
import classes from "./AnchorButton.module.scss";

const AnchorButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [rotate, setRotate] = useState(false);

  const handleScroll = () => {
    const scrolledHeight = window.pageYOffset;
    if (scrolledHeight > window.innerHeight) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className={classes.anchorButton}>
      <div
        className={`${classes.actionBtn} ${rotate ? classes.startBtn : ""}`}
        style={!isVisible ? { bottom: "73px" } : {}}
      >
        <img src={imgCall} alt="call" />
        <div className={classes.roundPush}>
          <Zoom in={rotate} style={{ transitionDelay: rotate && "700ms" }}>
            <a
              href="https://wa.me/996702052018"
              target="_blank"
              rel="noreferrer"
            >
              <img src={whatsapp} alt="whatsapp" />
            </a>
          </Zoom>
        </div>
        <div
          className={classes.actionBlock}
          onClick={() => setRotate((prev) => !prev)}
        ></div>
      </div>
      <button
        type="button"
        aria-label="Наверх"
        onClick={() => isVisible && scrollToTop()}
        className={`${classes.btn} ${isVisible ? classes.visible : ""}`}
      >
        <AnchorIcon />
      </button>
    </div>
  );
};

export default AnchorButton;
